import { styled } from '@linaria/react';
import { Handle, Position } from '@xyflow/react';
import { AgentEventTypes, type AgentEventLog } from '../../../../api/events-client/events-client.type';
import { inkLight, secondaryBase } from '../../../../styles/design-tokens';
import { Text } from '../../../../ui-library/typography/typography';
import { formatAgenticProcessDate } from '../../agentic-process-helpers';

interface DotNodeData {
  event?: AgentEventLog;
  isCurrentStatus?: boolean;
  inverse?: boolean;
  vertical?: boolean;
  connectToSelf?: boolean;
  tooltip?: string;
  isFrom?: boolean;
}

const DotNode = ({ data }: { data: DotNodeData }) => {
  const event = data?.event;
  const isCurrentTaskStatus = data?.isCurrentStatus;
  let sourcePosition = Position.Right;
  let targetPosition = Position.Left;

  if (data?.inverse === true) {
    sourcePosition = Position.Left;
    targetPosition = Position.Right;
  } else if (data?.vertical === true) {
    sourcePosition = Position.Top;
    targetPosition = Position.Bottom;
  } else if (data?.connectToSelf === true) {
    sourcePosition = Position.Right;
    targetPosition = Position.Right;
  }

  return (
    <DotContainer title={data?.tooltip || 'Dot node'} isCurrentTaskStatus={isCurrentTaskStatus}>
      {event?.event_type === AgentEventTypes.USER_PROMPT && event?.event_date && data?.isFrom && (
        <Text
          size="small"
          color={inkLight}
          style={{
            whiteSpace: 'nowrap',
            position: 'absolute',
            left: '-150px',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          {formatAgenticProcessDate(event.event_date)}
        </Text>
      )}
      <Handle type="target" position={targetPosition} style={{ opacity: 0 }} />
      <Handle type="source" position={sourcePosition} style={{ opacity: 0 }} />
    </DotContainer>
  );
};

interface HeaderNodeData {
  tooltip?: string;
  label?: string;
}

const HeaderNode = ({ data }: { data: HeaderNodeData }) => (
  <HeaderContainer title={data?.tooltip || 'Header node'}>
    <HeaderText>{data?.label || 'Header node'}</HeaderText>
    <Handle type="source" position={Position.Bottom} style={{ opacity: 0 }} />
  </HeaderContainer>
);

const DotContainer = styled.div<{ isCurrentTaskStatus?: boolean }>`
  position: relative;
  width: 12px;
  height: 12px;
  background-color: ${({ isCurrentTaskStatus }) => (isCurrentTaskStatus ? '#00C851' : 'transparent')};
  border: ${({ isCurrentTaskStatus }) => (isCurrentTaskStatus ? '2px solid #00C851' : 'none')};
  border-radius: ${({ isCurrentTaskStatus }) => (isCurrentTaskStatus ? '50%' : '0')};
  box-shadow: ${({ isCurrentTaskStatus }) => (isCurrentTaskStatus ? '0 0 8px rgba(0, 200, 81, 0.6)' : 'none')};
`;

const HeaderContainer = styled.div`
  position: relative;
  padding: 12px 20px;
  border-radius: 8px;
  border: 3px solid ${secondaryBase};
  background: ${secondaryBase};
  color: white;
  min-width: 160px;
  text-align: center;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
`;

const HeaderText = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export { DotNode, HeaderNode };
